// @ts-nocheck
/**
 * chat-media.js — Image upload + preview lifecycle for chat.
 */
(function () {
  'use strict';

  window.AIFlorist = window.AIFlorist || {};

  var render = null;
  var workerUrl = '';
  var inputEl = null;
  var fileInput = null;
  var previewBar = null;
  var previewThumbsEl = null;
  var multiPreviewEl = null;
  var maxImageDim = 1536;
  var maxBase64Length = 5600000;
  var isBusy = function () { return false; };
  var onLibrarySelectionSync = function () {};
  var pendingImages = []; // Array<ImageAttachment>
  var librarySelections = []; // Array<{ key, name }>
  var pickerSource = 'composer';

  function init(deps) {
    render = deps.render;
    workerUrl = deps.workerUrl || '';
    inputEl = deps.inputEl;
    fileInput = deps.fileInput;
    previewBar = deps.previewBar;
    previewThumbsEl = deps.previewThumbsEl;
    multiPreviewEl = deps.multiPreviewEl;
    maxImageDim = deps.maxImageDim || 1536;
    maxBase64Length = deps.maxBase64Length || 5600000;
    isBusy = deps.isBusy || isBusy;
    onLibrarySelectionSync = deps.onLibrarySelectionSync || onLibrarySelectionSync;
  }

  function bind(deps) {
    var uploadBtn = deps.uploadBtn;
    if (!uploadBtn || !fileInput) return;

    uploadBtn.addEventListener('click', function () {
      if (!isBusy()) openFilePicker({ fromWelcome: false });
    });
    fileInput.addEventListener('change', handleFileSelect);
  }

  function openFilePicker(opts) {
    if (!fileInput || isBusy()) return;
    pickerSource = (opts && opts.fromWelcome) ? 'welcome' : 'composer';
    fileInput.click();
  }

  function getPendingImage() {
    return pendingImages[0] || null;
  }

  function getPendingImages() {
    return pendingImages.slice();
  }

  function getLibrarySelections() {
    return librarySelections.slice();
  }

  function setLibrarySelections(items) {
    librarySelections = items || [];
    renderMultiPreview();
    updatePlaceholder();
  }

  function clearPendingImage() {
    pendingImages = [];
    if (previewBar) previewBar.style.display = 'none';
    if (previewThumbsEl) previewThumbsEl.innerHTML = '';
    if (render && typeof render.syncWelcomeReferenceButton === 'function') {
      render.syncWelcomeReferenceButton([]);
    }
    updatePlaceholder();
  }

  function removePendingImageByIndex(index) {
    if (index < 0 || index >= pendingImages.length) return;
    pendingImages.splice(index, 1);
    if (render && typeof render.syncWelcomeReferenceButton === 'function') {
      render.syncWelcomeReferenceButton(pendingImages);
    }
    if (previewBar) previewBar.style.display = 'none';
    if (previewThumbsEl) previewThumbsEl.innerHTML = '';
    updatePlaceholder();
  }

  function clearAll() {
    clearPendingImage();
    librarySelections = [];
    renderMultiPreview();
    updatePlaceholder();
    onLibrarySelectionSync(librarySelections);
  }

  function clearLibrarySelections() {
    librarySelections = [];
    renderMultiPreview();
    updatePlaceholder();
    onLibrarySelectionSync(librarySelections);
  }

  function updatePlaceholder() {
    if (!inputEl) return;
    if (pendingImages.length > 0 || librarySelections.length > 0) {
      inputEl.placeholder = 'Add a message about these references...';
    } else {
      inputEl.placeholder = 'Describe your dream bouquet...';
    }
  }

  function handleFileSelect(e) {
    var files = e.target.files ? Array.prototype.slice.call(e.target.files) : [];
    if (!files.length) return;
    fileInput.value = '';

    var imageFiles = files.filter(function (file) {
      return file && file.type && file.type.match(/^image\/(jpeg|png|webp|gif)$/);
    });
    if (!imageFiles.length) {
      render.systemError('Please upload a JPEG, PNG, or WebP image.');
      return;
    }

    Promise.all(imageFiles.map(processImageFile))
      .then(function (results) {
        pendingImages = pendingImages.concat(results).slice(0, 5);
        if (pickerSource === 'welcome') {
          if (previewBar) previewBar.style.display = 'none';
          if (previewThumbsEl) previewThumbsEl.innerHTML = '';
          if (render && typeof render.renderWelcomeReferenceThumbs === 'function') {
            render.renderWelcomeReferenceThumbs(pendingImages);
          }
        } else {
          renderPendingPreview();
          if (render && typeof render.syncWelcomeReferenceButton === 'function') {
            render.syncWelcomeReferenceButton(pendingImages);
          }
        }
        updatePlaceholder();
      })
      .catch(function (err) {
        render.systemError(err.message);
      });
  }

  function processImageFile(file) {
    return new Promise(function (resolve, reject) {
      var reader = new FileReader();
      reader.onload = function () {
        var img = new Image();
        img.onload = function () {
          var w = img.width;
          var h = img.height;
          if (w > maxImageDim || h > maxImageDim) {
            var ratio = Math.min(maxImageDim / w, maxImageDim / h);
            w = Math.round(w * ratio);
            h = Math.round(h * ratio);
          }

          var canvas = document.createElement('canvas');
          canvas.width = w;
          canvas.height = h;
          var ctx = canvas.getContext('2d');
          ctx.drawImage(img, 0, 0, w, h);

          var dataUrl = canvas.toDataURL('image/jpeg', 0.85);
          var base64 = dataUrl.split(',')[1];
          if (base64.length > maxBase64Length) {
            reject(new Error('Image is still too large after compression. Please try a smaller image.'));
            return;
          }

          resolve({
            mimeType: 'image/jpeg',
            data: base64,
            dataUrl: dataUrl,
          });
        };
        img.onerror = function () { reject(new Error('Could not read image.')); };
        img.src = reader.result;
      };
      reader.onerror = function () { reject(new Error('Could not read file.')); };
      reader.readAsDataURL(file);
    });
  }

  function renderPendingPreview() {
    if (!previewBar || !previewThumbsEl) return;
    if (pendingImages.length === 0) {
      previewThumbsEl.innerHTML = '';
      previewBar.style.display = 'none';
      return;
    }

    var html = '';
    for (var i = 0; i < pendingImages.length; i++) {
      var item = pendingImages[i];
      html +=
        '<div class="afc-preview-thumb-wrap" data-upload-index="' + i + '">' +
          '<img class="afc-preview-thumb" alt="Attached image ' + (i + 1) + '" src="' + escapeAttr(item.dataUrl) + '" />' +
          '<button class="afc-preview-remove" aria-label="Remove image" type="button">' +
            '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">' +
              '<line x1="18" y1="6" x2="6" y2="18"></line>' +
              '<line x1="6" y1="6" x2="18" y2="18"></line>' +
            '</svg>' +
          '</button>' +
        '</div>';
    }
    previewThumbsEl.innerHTML = html;
    previewBar.style.display = '';

    var wraps = previewThumbsEl.querySelectorAll('.afc-preview-thumb-wrap');
    for (var w = 0; w < wraps.length; w++) {
      (function (index, wrapEl) {
        var imgEl = wrapEl.querySelector('.afc-preview-thumb');
        var removeBtn = wrapEl.querySelector('.afc-preview-remove');
        if (imgEl) {
          imgEl.addEventListener('click', function () {
            if (render && typeof render.openImagePreview === 'function') {
              render.openImagePreview(pendingImages[index].dataUrl, 'Attached image preview');
            }
          });
        }
        if (removeBtn) {
          removeBtn.addEventListener('click', function () {
            pendingImages.splice(index, 1);
            renderPendingPreview();
            if (render && typeof render.syncWelcomeReferenceButton === 'function') {
              render.syncWelcomeReferenceButton(pendingImages);
            }
            updatePlaceholder();
          });
        }
      })(w, wraps[w]);
    }
  }

  // ── Multi-preview rendering (flower-library refs) ──────────────────
  function renderMultiPreview() {
    if (!multiPreviewEl) return;
    if (librarySelections.length === 0) {
      multiPreviewEl.innerHTML = '';
      return;
    }

    var html = '';
    for (var i = 0; i < librarySelections.length; i++) {
      var item = librarySelections[i];
      var thumbUrl = workerUrl + '/images/' + item.key;
      html +=
        '<div class="afc-preview-item" data-key="' + escapeAttr(item.key) + '">' +
          '<img src="' + thumbUrl + '" alt="' + escapeAttr(item.name) + '" />' +
          '<button class="afc-preview-item-remove" type="button" aria-label="Remove ' + escapeAttr(item.name) + '">&times;</button>' +
          '<span class="afc-preview-item-label">' + escapeAttr(item.name) + '</span>' +
        '</div>';
    }
    multiPreviewEl.innerHTML = html;

    var removeBtns = multiPreviewEl.querySelectorAll('.afc-preview-item-remove');
    for (var r = 0; r < removeBtns.length; r++) {
      removeBtns[r].addEventListener('click', handleRemoveLibItem);
    }
  }

  function handleRemoveLibItem(e) {
    var item = e.currentTarget.closest('.afc-preview-item');
    if (!item) return;
    var key = item.dataset.key;
    librarySelections = librarySelections.filter(function (s) { return s.key !== key; });
    renderMultiPreview();
    updatePlaceholder();
    onLibrarySelectionSync(librarySelections);
  }

  function escapeAttr(str) {
    if (!str) return '';
    return str.replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }

  window.AIFlorist.media = {
    init: init,
    bind: bind,
    getPendingImage: getPendingImage,
    getPendingImages: getPendingImages,
    getLibrarySelections: getLibrarySelections,
    setLibrarySelections: setLibrarySelections,
    clearLibrarySelections: clearLibrarySelections,
    clearPendingImage: clearPendingImage,
    removePendingImageByIndex: removePendingImageByIndex,
    clearAll: clearAll,
    openFilePicker: openFilePicker,
  };
})();
